import BottomModalState from "./BottomModalState";
import TutorialState from "./TutorialState";
import Room from "./Room";

export default class RoomState {
    constructor( room ) {
        this.room             = room ?? new Room();
        this.bottomModalState = new BottomModalState({
                obj:  room,
                type: 'content'
            }
        );
        this.tutorialState = new TutorialState();
    }
}
